import { AlertTriangle } from "lucide-react"

export interface WarningMessageBlockProps {
  title: string
  description: string
}

export const WarningMessageBlock = ({
  title,
  description,
}: WarningMessageBlockProps) => {
  return (
    <div className="rounded-md border border-amber-200/70 bg-amber-50/60 p-4 text-foreground dark:border-amber-900/50 dark:bg-amber-950/15">
      <div className="flex items-start gap-3">
        <div className="mt-0.5 rounded-full bg-amber-100 p-1 text-amber-700 dark:bg-amber-950/80 dark:text-amber-300">
          <AlertTriangle className="h-4 w-4" />
        </div>
        <div className="space-y-1">
          <div className="font-medium text-foreground">{title}</div>
          <p className="text-sm leading-6 text-muted-foreground">
            {description}
          </p>
        </div>
      </div>
    </div>
  )
}
